import { apiIsomorphicFetchInvite } from '#/api/invite/apiFetchInvite';
import { authSignupRoute } from '#/modules/auth/routing/auth.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getAppRouteSearchParams } from '#/routing/utils/getAppRouteSearchParams';

import { SignupPageLoadable } from './SignupPageLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof authSignupRoute>) {
  const { invite: inviteId } = getAppRouteSearchParams({
    url: request.url,
    route: authSignupRoute,
  });

  const [invite] = await Promise.all([
    inviteId
      ? apiIsomorphicFetchInvite({ request, context })(inviteId)
      : Promise.resolve(null),
    SignupPageLoadable as unknown as Promise<unknown>,
  ]);

  return { invite };
}

export default function AuthSignupHorizonRoute({
  loaderData: { invite },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return <SignupPageLoadable invite={invite} />;
}
